// extracted by mini-css-extract-plugin
export default {"cautionBox":"h9-z"};